function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import SvgIcon from "./SvgIcon";
const EcoOutlined = (props)=>{
    return /*#__PURE__*/ _jsx(SvgIcon, _objectSpread({}, props, {
        viewBox: "0 0 48 48",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M24 39.8q-2.95 0-5.525-.975T13.8 36.1l-3.1 3.05q-.45.45-1.025.45t-1.025-.45q-.45-.45-.45-1.025t.45-1.025L11.7 34q-1.75-2.1-2.725-4.675Q8 26.75 8 23.8q0-6.7 4.65-11.35Q17.3 7.8 24 7.8h16v16q0 6.7-4.65 11.35Q30.7 39.8 24 39.8Zm0-3q5.4 0 9.2-3.8 3.8-3.8 3.8-9.2v-13H24q-5.4 0-9.2 3.8-3.8 3.8-3.8 9.2 0 2.3.75 4.375T13.8 31.9l10.85-10.8q.45-.45 1.025-.45t1.025.45q.45.45.45 1.05 0 .6-.45 1.05L15.9 34q1.65 1.3 3.725 2.05 2.075.75 4.375.75Zm0-13Z"
        })
    }));
};
export default /*#__PURE__*/ memo(EcoOutlined);
